export const impactStats = [
  {
    label: "Regenerative fibers",
    value: 92,
    suffix: "%",
    decimals: 0,
    description: "Of all materials in our current collection are certified regenerative or organic.",
  },
  {
    label: "Carbon sequestered",
    value: 1.4,
    suffix: "×",
    decimals: 1,
    description: "More carbon removed from the atmosphere than our entire operation emits annually.",
  },
  {
    label: "Water saved",
    value: 2.3,
    suffix: "M L",
    decimals: 1,
    description: "Liters of water saved versus conventional production, through rainwater irrigation and closed-loop dyeing.",
  },
  {
    label: "Living wage partners",
    value: 100,
    suffix: "%",
    decimals: 0,
    description: "Of everyone in our supply chain earns above the local living wage, with profit share on top.",
  },
];

export const initiatives = [
  {
    icon: "ri-drop-line",
    title: "Closed-Loop Dyeing",
    body: "Our botanical dye facility recycles 97% of process water. What leaves the plant is cleaner than what arrived.",
  },
  {
    icon: "ri-plant-line",
    title: "Rewilding Partnership",
    body: "For every garment sold, we fund the restoration of one square meter of native grassland in Trás-os-Montes.",
  },
  {
    icon: "ri-recycle-line",
    title: "Zero-Waste Pattern Making",
    body: "Our cutting method leaves less than 3% fabric waste. Scraps become stuffing, insulation, or compost.",
  },
  {
    icon: "ri-box-3-line",
    title: "Plastic-Free Packaging",
    body: "Every order ships in a reusable organic cotton bag inside a recycled cardboard box sealed with plant-based adhesive.",
  },
  {
    icon: "ri-tools-line",
    title: "Lifetime Repairs",
    body: "Every Verdant garment includes free repairs for ten years. Send it back. We fix it, clean it, and return it to you.",
  },
  {
    icon: "ri-earth-line",
    title: "Local Sourcing Radius",
    body: "89% of our raw materials travel less than 800 kilometers before reaching our Porto atelier.",
  },
];

export const materials = [
  {
    name: "Regenerative Cotton",
    origin: "Alentejo, Portugal",
    description:
      "Grown on farms that rotate with legumes and livestock to rebuild soil organic matter. No synthetic pesticides. No irrigation beyond rainfall.",
    image:
      "https://readdy.ai/api/search-image?query=raw%20organic%20cotton%20bolls%20and%20fluffy%20white%20cotton%20fibers%20on%20warm%20cream%20linen%20fabric%20background%2C%20natural%20soft%20light%2C%20artisanal%20textile%20material%20detail%20photography%2C%20earth%20tone%20palette%2C%20sustainable%20raw%20fiber%20editorial%20shot%2C%20fine%20art%20composition&width=800&height=600&seq=verdant-mat-1&orientation=landscape",
  },
  {
    name: "European Flax Linen",
    origin: "Normandy, France",
    description:
      "The world's most sustainable fiber crop. Flax grows with zero irrigation, improves soil structure, and every part of the plant is used.",
    image:
      "https://readdy.ai/api/search-image?query=natural%20linen%20flax%20fibers%20and%20woven%20linen%20fabric%20swatches%20in%20warm%20beige%20oat%20tones%20on%20cream%20surface%2C%20artisanal%20textile%20material%20detail%20photography%2C%20soft%20natural%20light%2C%20earth%20tone%20palette%2C%20sustainable%20fiber%20editorial%20shot%2C%20fine%20art%20composition&width=800&height=600&seq=verdant-mat-2&orientation=landscape",
  },
  {
    name: "Peace Silk",
    origin: "Assam, India",
    description:
      "Ahimsa silk allows the moth to emerge before the cocoon is harvested. The resulting fiber has a slightly more matte, raw texture — and a conscience.",
    image:
      "https://readdy.ai/api/search-image?query=raw%20peace%20silk%20cocoon%20fibers%20and%20woven%20silk%20fabric%20swatch%20in%20warm%20cream%20ivory%20tones%20on%20soft%20linen%20background%2C%20artisanal%20textile%20material%20detail%20photography%2C%20natural%20soft%20light%2C%20earth%20tone%20palette%2C%20sustainable%20fiber%20editorial%20shot%2C%20fine%20art%20mood&width=800&height=600&seq=verdant-mat-3&orientation=landscape",
  },
  {
    name: "British Wool",
    origin: "Yorkshire Dales, UK",
    description:
      "Sourced from small flocks raised on permanent pasture. The fiber is naturally water-resistant, temperature-regulating, and biodegradable within months.",
    image:
      "https://readdy.ai/api/search-image?query=raw%20natural%20wool%20fleece%20fibers%20and%20woven%20wool%20fabric%20swatch%20in%20warm%20cream%20oatmeal%20tones%20on%20soft%20linen%20background%2C%20artisanal%20textile%20material%20detail%20photography%2C%20natural%20soft%20light%2C%20earth%20tone%20palette%2C%20sustainable%20fiber%20editorial%20shot%2C%20fine%20art%20composition&width=800&height=600&seq=verdant-mat-4&orientation=landscape",
  },
];

export const certifications = [
  { name: "GOTS Certified", issuer: "Global Organic Textile Standard", year: "2019" },
  { name: "B Corp", issuer: "B Lab", year: "2021" },
  { name: "OEKO-TEX Standard 100", issuer: "Hohenstein", year: "2020" },
  { name: "Fair Trade Certified", issuer: "Fairtrade International", year: "2022" },
  { name: "Cradle to Cradle Certified", issuer: "MBDC", year: "2023" },
  { name: "Climate Neutral", issuer: "Climate Neutral", year: "2024" },
];